class PmCarousel extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.viewport = this.querySelector('[data-carousel-viewport]');
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = [...this.querySelectorAll('[data-carousel-slide]')];
    this.previous = this.querySelector('[data-carousel-previous]');
    this.next = this.querySelector('[data-carousel-next]');
    this.dots = [...this.querySelectorAll('[data-carousel-dot]')];

    if (!this.viewport || !this.track || this.slides.length === 0) return;

    this.previous?.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
    this.next?.addEventListener('click', () => this.goTo(this.currentIndex() + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
    this.viewport.addEventListener('scroll', () => this.queueUpdate(), { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.viewport);
    this.dataset.ready = 'true';
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  currentIndex() {
    const width = this.slides[0]?.getBoundingClientRect().width || 1;
    return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.viewport.scrollLeft / width)));
  }

  goTo(index) {
    const safeIndex = Math.max(0, Math.min(this.slides.length - 1, index));
    const left = this.slides[safeIndex]?.offsetLeft || 0;
    this.viewport.scrollTo({ left, behavior: 'smooth' });
  }

  queueUpdate() {
    cancelAnimationFrame(this.updateFrame);
    this.updateFrame = requestAnimationFrame(() => this.update());
  }

  update() {
    const index = this.currentIndex();
    const visible = Math.max(1, Math.round(this.viewport.clientWidth / (this.slides[0]?.getBoundingClientRect().width || 1)));
    const visibleSlides = this.slides.slice(index, index + visible);
    const visibleHeight = Math.max(...visibleSlides.map((slide) => slide.scrollHeight), 0);
    if (visibleHeight > 0) this.track.style.height = `${visibleHeight}px`;
    this.previous?.toggleAttribute('disabled', index === 0);
    this.next?.toggleAttribute('disabled', index + visible >= this.slides.length);
    this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
  }
}

if (!customElements.get('pm-carousel')) {
  customElements.define('pm-carousel', PmCarousel);
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('pm-carousel').forEach((carousel) => carousel.connectedCallback());
});




document.querySelectorAll('.pk-menu-toggle').forEach(function (button) {
  button.addEventListener('click', function () {

    var menu = document.querySelector('#pk-main-menu');

    if (menu.classList.contains('hidden')) {

      menu.classList.remove('hidden');

      document.querySelectorAll('.pk-menu-toggle').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
        btn.setAttribute('aria-label', 'Close menu');
      });

    } else {

      menu.classList.add('hidden');

      document.querySelectorAll('.pk-menu-toggle').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', 'Open menu');
      });

    }

  });
});
